var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBall = function SvgBall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.781 4.987a16.25 16.25 0 0 1 21.458 9.37 1.26 1.26 0 0 1 .166.472 16.25 16.25 0 1 1-30.81 0 1.255 1.255 0 0 1 .166-.472 16.25 16.25 0 0 1 9.02-9.37Zm-7.12 11.675a13.75 13.75 0 0 0 3.936 13.37l3.046-3.51-2.587-8.156-4.395-1.704Zm5.223-.657L7.487 14.3A13.75 13.75 0 0 1 18.75 6.307v4.722l-6.866 4.976Zm9.366-4.976 6.866 4.976 4.397-1.705A13.75 13.75 0 0 0 21.25 6.307v4.722Zm12.089 5.633-4.395 1.704-2.546 8.026 3.021 3.625a13.75 13.75 0 0 0 3.92-13.355Zm-5.89 14.896-3.034-3.641h-8.673l-3.17 3.654a13.746 13.746 0 0 0 14.877-.013ZM13.53 17.899l2.384 7.518h8.17l2.384-7.518L20 13.211l-6.469 4.688Z",
    clipRule: "evenodd"
  })));
};
export default SvgBall;